<template>
  <div
    class="save-button"
    @click="onSaveSelected"
    :tabindex="tabNavigationEnabled ? 0 : null"
    @keyup.enter="onSaveSelected"
  >
    <span class="save-text" v-localize="SAVE_BUTTON_TEXT_KEY" />
  </div>
</template>

<script>
import { LocalizationDirective } from '@/directives/LocalizationDirective';
import DebouncedHandler from '@/services/DebouncedHandler';

export default {
  name: 'SaveCategory',
  props: ['tabNavigationEnabled'],
  components: {},
  created: function() {
    this.SAVE_BUTTON_TEXT_KEY = 'CategorySaveButtonTitle';
  },
  directives: {
    LocalizationDirective,
  },
  methods: {
    onSaveSelected: DebouncedHandler(function() {
      this.$store.dispatch('saveAvatar');
    }),
  },
};
</script>

<style scoped>
.save-button {
  cursor: pointer;
  position: relative;
  color: white;
  background-color: #0a92ff;
  line-height: 50px;
  width: 70%;
  border-radius: 25pt;
  text-align: center;
  box-shadow: 0 1pt 4pt rgba(0, 0, 0, 0.14);
}

.save-text {
  font-weight: bold;
  font-size: 18px;
}
</style>
